import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { NewsletterFormComponentDef } from '@df/session/newsletter/newsletter-form.component.def';
import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';
import { NOTICES } from '@df/ui/api/notice/notice.const';
import { validatePatternConfiguration } from '@df/ui/form/validate-pattern.config';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../module/legacy/forms/mui-input.directive';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/api/result.component';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';

export const SESSION_STORAGE_FLAG_NAME = 'customNewsletterForm';

@Component({
    selector: 'newsletter-form',
    templateUrl: './newsletter-form.html',
    styleUrls: ['./newsletter-form.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ResultComponent,
        ActionComponent,
        MuiInputDirective,
        TranslationModule,
        NgClass,
        FormsModule,
        InputWrapComponent,
        InputWrapBodyDirective
    ]
})
export class NewsletterFormComponent extends NewsletterFormComponentDef {
    constructor(
        protected override _ref: ChangeDetectorRef,
        protected override timeoutService: TimeoutService,
        protected sessionStorageService: SessionStorageService,
        protected router: Router
    ) {
        super(_ref, timeoutService);
    }
    protected isValid = false;
    protected _showSubmitButton = false;
    set showSubmitButton(value) {
        this._showSubmitButton = value;
        this._ref.detectChanges();
    }
    get showSubmitButton() {
        return this._showSubmitButton;
    }

    override _submit(): void {
        this.validate();
        if (this.isValid) {
            const data = <Newsletter.ISubscriptionFormData>{ source: this.source, ...this.data };
            this.sessionStorageService.set(SESSION_STORAGE_FLAG_NAME, data);
            this.form?.resetForm();
            this.router.navigate(['/signup']);
        }
    }

    validate(): void {
        let email = this.form?.form.value?.email;
        if (email === undefined || email === '') {
            this.status.error = NOTICES['REQUIREDFIELD'];
            this.isValid = false;
        } else if (email && this.pattern && !email.match(this.pattern)) {
            this.status.error = this.patternError;
            this.isValid = false;
        } else {
            this.isValid = true;
            this.status.reset();
        }
    }

    get pattern(): string | RegExp {
        return validatePatternConfiguration['email'].pattern;
    }

    get patternError(): string | undefined {
        return validatePatternConfiguration['email'].errorMessage;
    }
}
